import { useState } from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Text from '../../../../../shared/Text';
import { BadgeList } from './BadgeList.jsx';
import { DeletePrizeModal } from '../../Prizes/DeletePrizeModal.jsx';

import { useScrollContext } from '../../../contexts/ScrollContext.jsx';

import { scrollToRef } from '../../../utils/scrollTo';
import { parseDate, timeOptions } from '../../../utils/helpers';

export const PostItem = ({ post, tiles, t }) => {
  const { postRefs } = useScrollContext();
  const { prize } = post;
  const tilesCount = tiles[`post-${post.uuid}`]?.length;
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const parsedTimes = timeOptions(post.boardTimezone);

  return (
    <Post
      key={post.uuid}
      onClick={() => scrollToRef(postRefs.current[post.uuid])}
    >
      <PostDate>
        {parseDate(post.publishDate, t('postSummary.noDate'), 'iii MM/d')}
      </PostDate>
      <PostTime>
        {post.sendHour !== null &&
          post.sendHour !== undefined &&
          parsedTimes.find(option => option.value === post.sendHour).label}
      </PostTime>
      <TileCount variant="subtitle2">
        {prize
          ? t(`postSummary.prizeStatus.${prize.status}`, {
              count: tilesCount,
            })
          : t('postSummary.tileCount', { count: tilesCount })}
      </TileCount>
      <BadgeList status={post.status} />
      {prize && (
        <>
          <DeletePrizeModal
            open={openDeleteModal}
            setOpen={setOpenDeleteModal}
            prize={prize}
          />
        </>
      )}
    </Post>
  );
};

const TileCount = styled(Text)`
  display: inline-block;
  margin-right: 12px;
  text-align: right;
  letter-spacing: -0.1px;
`;

const Post = styled.li`
  display: grid;
  grid-template-columns: 80px 100px 1fr 100px;
  padding: 8px;
  cursor: pointer;
  align-items: center;
  border-bottom: 1px solid ${themeGet('colors.black.10')};
  &:first-child {
    border-top: 1px solid ${themeGet('colors.black.10')};
  }
  &:hover {
    background: ${themeGet('colors.black.5')};
  }
`;

const PostTime = styled(Text).attrs({
  variant: 'subtitle2',
  color: 'black.80',
})`
  text-align: left;
  text-wrap: nowrap;
`;

const PostDate = styled(Text).attrs({
  variant: 'button',
})`
  display: flex;
  align-items: center;
  justify-content: left;
`;
